document.addEventListener('alpine:init', () => {
    Alpine.data('accordion', () => ({
        open: false,

        toggle() {
            this.open = ! this.open
        },
    }))
})